<template>
	<div>
		<div class="title-container">
			<div class="title">Manage {{ tag.name }}</div>
			<module-page-buttons-component></module-page-buttons-component>
		</div>

		<form @submit.prevent="addTagSubmit" action>
			<div class="search-container">
				<div class="search-box"><input placeholder="Type New Tag & Press Enter" type="text" v-model="addForm.name"></div>
				<div class="search-icon"><span class="fa fa-plus"></span></div>
			</div>
		</form>

		<nothing-here v-if="tags.length === 0"></nothing-here>

		<div class="conjoin-input-containers">
			<form v-for="tag in sortedTags" :key="`tag-${ tag.id }`" action @submit.prevent="editTagSubmit(tag.id)" class="input-container">
				<div class="input-box"><input type="text" :ref="`edit_${tag.id}`" v-model="editForm[tag.id].name" @focus="editTag(tag)" :readonly="!isEditing(tag)"></div>

				<div v-if="isEditing(tag)" class="inline-buttons">
					<a v-if="isEditing(tag)" href @click.prevent="editTagSubmit(tag.id)"><div class="hover-title">Save Changes</div><span class="fa fa-save"></span></a>
					<a v-if="isEditing(tag)" href @click.prevent="cancelEdit(tag.id)"><div class="hover-title">Cancel Update</div><span class="fa fa-undo"></span></a>
				</div>

				<div v-if="isConfirmingDelete(tag)" class="inline-buttons">
					<a v-if="isConfirmingDelete(tag)" href @click.prevent="confirmDelete(tag)"><div class="hover-title">Confirm Delete</div><span class="fa fa-trash"></span></a>
					<a v-if="isConfirmingDelete(tag)" href @click.prevent="$set(editForm[tag.id], 'deleting', false)"><div class="hover-title">Cancel</div><span class="fa fa-undo"></span></a>
				</div>

				<div v-if="!isEditing(tag) && !isConfirmingDelete(tag)" class="inline-buttons">
					<a v-if="!isEditing(tag) && !isConfirmingDelete(tag)" href @click.prevent="editTag(tag)"><div class="hover-title">Update</div><span class="fa fa-pencil"></span></a>
					<a v-if="!isEditing(tag) && !isConfirmingDelete(tag)" href @click.prevent="clickDelete(tag)"><div class="hover-title">Delete</div><span class="fa fa-trash"></span></a>
				</div>
				<button type="submit" style="display:none"></button>
			</form>
		</div>
	</div>
</template>

<script>

import { mapGetters } from 'vuex';
import _ from 'underscore';
import ModulePageButtonsComponent from './components/ModulePageButtonsComponent';

export default {

	name: 'ModuleTagPage',

	async asyncData({ app, route, store }) {
		const { data } = await app.$api.get(`/tags/${route.params.slug}/${route.params.id}`);

		store.dispatch('setActiveModule', data.module);

		const editForm = {};
		data.tags.forEach(tag => {
			editForm[tag.id] = { ...tag, editing: false };
		});

		return {
			loadedData: data.tags,
			editForm,
		};
	},

	data() {
		return {
			loadedData: {},
			loaded: false,
			tags: [],
			addForm: {},
			editForm: {},
		};
	},

	computed: {
		...mapGetters(['module']),

		tag() {
			return _.find(this.module.fields, (field) => field.id == this.$route.params.id) || { name: 'Tag' };
		},

		sortedTags() {
			return _.sortBy(this.tags, (tag) => (tag + '').toLowerCase());
		},
	},

	created() {
		this.setData(this.loadedData);
	},

	methods: {
		setData(tags) {
			this.$store.commit('setHeaderButtons', [{ title: 'Back To ' + this.module.name, icon: 'fa fa-chevron-left', link: this.module.url_path_prefix + this.module.slug }]);

			this.tags = tags;
			this.loaded = true;
		},

		async addTagSubmit() {
			const { data } = await this.$api.post(`/tags/${this.module.slug}`, {
				name: this.addForm.name,
				module: this.module.slug,
				module_field_id: this.$route.params.id,
			});

			this.tags.unshift(data);
			this.$set(this.editForm, data.id, { ...data, editing: false });

			this.$store.dispatch('addToast', `Added ${this.addForm.name}`);
			this.addForm = {};
		},

		isEditing(tag) {
			return !!this.editForm[tag.id].editing;
		},

		isConfirmingDelete(tag) {
			return !!this.editForm[tag.id].deleting;
		},

		editTag(tag) {
			this.$set(this.editForm[tag.id], 'editing', true);
			this.$nextTick(() => {
				this.$refs[ `edit_${tag.id}` ][ 0 ].focus();
			});
		},

		clickDelete(tag) {
			this.$set(this.editForm[tag.id], 'deleting', true);
		},

		cancelEdit(tagId) {
			this.$set(this.editForm[tagId], 'editing', false);
			let index = _.findIndex(this.tags, { id: tagId });
			if (index !== -1) this.$set(this.editForm[tagId], 'name', this.tags[index].name);
		},

		async editTagSubmit(tagId) {
			const { data } = await this.$api.post(`/tags/${this.module.slug}/${tagId}`, {
				name: this.editForm[tagId].name,
				module: this.module.slug,
				module_field_id: this.$route.params.id,
			});

			let index = _.findIndex(this.tags, { id: tagId });
			if (index !== -1) this.tags[ index ] = data;

			this.$store.dispatch('addToast', `${this.editForm[tagId].name} Updated`);
			this.$set(this.editForm[tagId], 'editing', false);
		},

		async confirmDelete(tag) {
			try {
				await this.$api.post(`/tags/${this.module.slug}/${tag.id}/delete`);

				this.$store.dispatch('addToast', `${tag.name} Deleted`);
				const index = _.findIndex(this.tags, tag);

				if (index !== -1) {
					this.tags.splice(index, 1);
				}
			} catch (e) {
				this.$store.dispatch('errorToast', 'There was a problem deleting that tag. Please try again soon.');
			}
		},

	},

	components: {
		ModulePageButtonsComponent,
	},
};

</script>
